import { Injectable, inject } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { SKIP_GLOBAL_HTTP_ERROR_UI } from '@core/services/http/http-context.tokens';
import type {
  FundingTransaction,
  InvestorContext,
  LaunchpadOffering,
} from '../models/launchpad.types';
import { LaunchpadApiService } from './launchpad-api.service';

@Injectable({ providedIn: 'root' })
export class LaunchpadApiFacade {
  private readonly api = inject(LaunchpadApiService);

  private mutationOptions(): { context: HttpContext } {
    return { context: new HttpContext().set(SKIP_GLOBAL_HTTP_ERROR_UI, true) };
  }

  getOfferings(): Observable<LaunchpadOffering[]> {
    return this.api.getOfferings();
  }

  getOffering(projectId: number): Observable<LaunchpadOffering> {
    return this.api.getOffering(projectId);
  }

  getInvestorContext(
    fundraiseStatus: LaunchpadOffering['fundraiseStatus'],
  ): Observable<InvestorContext> {
    return this.api.getInvestorContext(fundraiseStatus);
  }

  recordLocalInvestment(tx: FundingTransaction): void {
    void this.mutationOptions();
    this.api.recordLocalInvestment(tx);
  }

  getMyInvestments(): Observable<FundingTransaction[]> {
    return this.api.getMyInvestments();
  }
}
